exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-pdf{position:fixed;top:0;left:0;bottom:0;right:0;width:100%;height:100%;background:rgba(0,0,0,0.6);z-index:9999;text-align:center}.ecks,.next-page,.prev-page{position:absolute;font-size:46px;color:#fff;cursor:pointer;top:45%;transition:color 0.2s ease}.next-page{right:20px}.ecks:hover,.next-page:hover,.prev-page:hover{color:#911}.prev-page{left:20px}.pdf-document canvas{margin:0 auto;height:100vh !important;width:auto !important}.ecks{top:5%;right:5%}\n", ""]);

// exports
